<template>
  <div class="country-link">
    <router-link :to="`/${encodedName}`" class="morelink">{{country.displayName}}</router-link>
  </div>
</template>

<script>
export default {
  name: 'CountryLink',
  props: ["country"],
  computed: {
    encodedName () {
      return this.country.name.replace(/ /g, "-");
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.country-link {
  display: flex;
}
a.morelink {
  display: flex;
  align-items: center;
  line-height:16px;
  margin-bottom: 5px;
  flex-shrink: 0;
}

</style>
